import { useCallback } from "react";

export const useFormattedBalance = () => {
  const getFormattedBalance = useCallback((value: number | null): string => {
    return value !== null ? `$${value.toLocaleString()}K` : "";
  }, []);

  return { getFormattedBalance };
};
